import React, { PureComponent } from 'react'
import { Card, CardMedia } from 'material-ui/Card'
import { Rating } from 'material-ui-rating'
import FlatButton from 'material-ui/FlatButton'
import IconButton from 'material-ui/IconButton'
import FontIcon from 'material-ui/FontIcon'
import { Row, Col } from 'pui-react-grids'
import FixedImg from './FixedImg'
import { Link } from 'react-router-dom'
import { themeColors } from '../styles/theme'
import moment from 'moment'
import {
  getProponenteItems,
  getDestinatarioItems,
  getProponenteCash,
  getDestinatarioCash,
  getProponenteEsito,
  getDestinatarioEsito,
} from '../utils'

const VERTIAL_SHIFT = 98
const BASE_HEIGHT = 110
const ITEM_INC_HEIGHT = 12

const iconStyle = {
  color: themeColors.lightblack,
}

const styles = {
  ExchangeDateContainer: {
    backgroundColor: '#828282',
    color: themeColors.white,
    paddingLeft: '5px',
    width: '100%',
  },
  ProponenteContainer: {
    backgroundColor: '#E8E8E8',
    color: themeColors.lightblack,
    marginLeft: '10px',
    marginRight: '10px',
    marginTop: '10px',
  },
  DestinatarioContainer: {
    backgroundColor: '#E8E8E8',
    color: themeColors.lightblack,
    marginRight: '10px',
    marginLeft: '10px',
    marginTop: '10px',
  },
  UserTitle: {
    paddingTop: '5px',
    paddingLeft: '20px',
    marginBottom: '0px',
  },
  userLabel: {
    marginLeft: 'auto',
    textTransform: 'uppercase',
    fontSize: 10,
    padding: 10,
  },
  TradedItems: {
    paddingLeft: 20,
    display: 'flex',
  },
  remainingDays: {
    fontSize: 9,
    marginLeft: 8,
    backgroundColor: themeColors.lightblack,
    paddingLeft: 3,
    paddingRight: 3,
    borderRadius: 2,
    paddingTop: 4,
  },
  remDayNum: {
    color: themeColors.positive,
  },
  feedback: {
    paddingLeft: 16,
    marginTop: 0,
    marginBottom: 10,
    fontSize: 13,
  },
  place: {
    fontStyle: 'italic',
    paddingLeft: 16,
    marginTop: 0,
    marginBottom: 3,
    fontSize: 13,
  },
  itemTitle: {
    padding: 16,
    fontSize: 15,
  },
  exchageState: {
    backgroundColor: themeColors.energized,
    color: themeColors.lightblack,
    marginLeft: 10,
    marginRight: 10,
    display: 'flex',
  },
  exchageStateText: {
    margin: 0,
    color: themeColors.white,
    fontSize: 14,
    textTransform: 'uppercase',
    padding: 8,
    paddingTop: 9,
    paddingLeft: 16,
    marginRight: 'auto',
    display: 'inline-flex',
    lineHeight: 1.5,
  },
  detailBtn: {
    marginLeft: 'auto',
  },
  hideBtn: {
    color: themeColors.white,
    padding: 2,
    marginLeft: 10,
    width: 20,
    height: 20,
  },
  feedbackStars: {
    width: 16,
    height: 16,
    padding: 3,
    position: 'relative',
    top: -2,
    left: 3,
  },
  swapLoading: {
    opacity: 0.5,
    pointerEvents: 'none',
  },
}

const exchangeArrowStyle = {
  horizontal: {
    marginTop: '50px',
  },
  vertical: {
    marginTop: 10,
    marginBottom: 10,
  },
}

const objectCardStyle = {
  containerStyle: {
    height: 100,
    display: 'flex',
    opacity: 1,
    backgroundColor: '#fff',
  },
  cardStyle: {
    margin: 10,
  },
}

const expandBtnStyle = {
  position: 'relative',
  top: 24,
}

export default class ExchangeCard extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      expandedProponente: false,
      expandedDestinatario: false,
    }
  }

  toggleExpandProponente = e => {
    e.preventDefault()
    this.setState({ expandedProponente: !this.state.expandedProponente })
  }

  toggleExpandDestinatario = e => {
    e.preventDefault()
    this.setState({ expandedDestinatario: !this.state.expandedDestinatario })
  }

  handleOnHideClick = e => {
    this.props.onHideClick(this.props.swap)
  }

  render() {
    const { swap, loading } = this.props

    const proponenteItems = getProponenteItems(swap)
    const proponenteCash = getProponenteCash(swap)
    const proponenteEsito = getProponenteEsito(swap)
    const proponenteCollapsedHeight =
      BASE_HEIGHT + ITEM_INC_HEIGHT * (proponenteItems.length - 1)

    const destinatarioItems = getDestinatarioItems(swap)
    const destinatarioCash = getDestinatarioCash(swap)
    const destinatarioEsito = getDestinatarioEsito(swap)

    const destinatarioCollapsedHeight =
      BASE_HEIGHT + ITEM_INC_HEIGHT * (destinatarioItems.length - 1)

    const daysLeft = moment(swap.created_at)
      .add(8, 'days')
      .diff(moment(), 'days')

    return (
      <Card
        className="ExchangeCard"
        style={loading ? styles.swapLoading : loading}>
        <Row>
          <div style={styles.exchageState}>
            <p style={styles.exchageStateText}>
              {swap.stato}{' '}
              {daysLeft > 0 &&
                swap.stato === 'proposta' && (
                  <span style={styles.remainingDays}>
                    Giorni rimanenti:{' '}
                    <span style={styles.remDayNum}>{daysLeft}</span>
                  </span>
                )}
              {swap.stato === 'accettata' && (
                <span style={styles.remainingDays}>
                  in data{' '}
                  <span style={styles.remDayNum}>
                    {moment(swap.updated_at).format('D MMMM YYYY')}
                  </span>
                </span>
              )}
              {swap.stato !== 'proposta' &&
                swap.stato !== 'accettata' &&
                swap.stato !== 'conclusa' && (
                  <IconButton
                    onClick={this.handleOnHideClick}
                    style={styles.hideBtn}
                    iconStyle={{ color: themeColors.white, fontSize: 16 }}
                    tooltip="Cancella definitivamente la proposta">
                    <FontIcon className="material-icons">delete</FontIcon>
                  </IconButton>
                )}
            </p>
            <Link to={`/swap/${swap.id}`}>
              <FlatButton
                label="Vedi Dettaglio"
                primary={true}
                style={styles.detailBtn}
              />
            </Link>
          </div>
          <Col md={10} sm={10} xs={24}>
            <div style={styles.ProponenteContainer}>
              <div style={{ display: 'flex' }}>
                <div style={styles.UserTitle}>
                  <Link
                    to={`/user/${swap.proponente.username}`}
                    style={{ color: themeColors.primary }}>
                    {swap.proponente.username}
                  </Link>
                </div>
                <div style={styles.userLabel}>Proponente</div>
              </div>
              <div style={{ display: 'flex' }}>
                <div>
                  <p style={styles.place}>
                    <FontIcon className="material-icons" style={iconStyle}>
                      place
                    </FontIcon>
                    <span style={{ position: 'relative', top: -7 }}>
                      {swap.proponente.district}
                    </span>
                  </p>
                  <div style={{ height: 29 }}>
                    {proponenteEsito &&
                      +proponenteEsito.feedback > 0 && (
                        <div style={{ display: 'inline-flex' }}>
                          <p style={styles.feedback}>Feedback</p>
                          <Rating
                            value={proponenteEsito.feedback}
                            readOnly={true}
                            itemStyle={styles.feedbackStars}
                            itemIconStyle={{ width: 17, height: 17 }}
                          />
                        </div>
                      )}
                  </div>
                </div>
                <div style={{ marginLeft: 'auto' }}>
                  {proponenteItems.length === 0 ? (
                    <FlatButton
                      style={expandBtnStyle}
                      label={`${proponenteCash} €`}
                      primary={true}
                    />
                  ) : (
                    <FlatButton
                      style={expandBtnStyle}
                      label={`${proponenteItems.length} oggett${
                        proponenteItems.length > 1 ? 'i' : 'o'
                      }${proponenteCash ? ` + ${proponenteCash} €` : ''}`}
                      labelPosition="before"
                      onClick={this.toggleExpandProponente}
                      primary={true}
                      icon={
                        proponenteItems.length > 1 && (
                          <FontIcon className="material-icons">
                            {this.state.expandedProponente
                              ? 'keyboard_arrow_up'
                              : 'keyboard_arrow_down'}
                          </FontIcon>
                        )
                      }
                    />
                  )}
                </div>
              </div>
            </div>

            {!!proponenteItems.length && (
              <div
                style={
                  this.state.expandedProponente
                    ? {}
                    : {
                        position: 'relative',
                        height: proponenteCollapsedHeight,
                      }
                }>
                {proponenteItems.map((item, i) => (
                  <Card
                    key={item.oggetto.id}
                    containerStyle={objectCardStyle.containerStyle}
                    style={
                      this.state.expandedProponente
                        ? objectCardStyle.cardStyle
                        : {
                            position: 'relative',
                            top: -VERTIAL_SHIFT * i,
                            margin: 10,
                          }
                    }>
                    <CardMedia>
                      <FixedImg src={item.oggetto.immagine} height={100} />
                    </CardMedia>
                    <div style={styles.itemTitle}>{item.oggetto.titolo}</div>
                  </Card>
                ))}
              </div>
            )}
          </Col>

          <Col md={4} sm={4} xs={24} style={{ textAlign: 'center' }}>
            <div style={exchangeArrowStyle.horizontal} className="hidden-xs">
              <img alt="HorizontalTrade" src="/img/HorizontalTrade.png" />
            </div>
            <div
              style={exchangeArrowStyle.vertical}
              className="hidden-sm hidden-md hidden-lg">
              <img alt="VerticalTrade" src="/img/VerticalTrade.png" />
            </div>
          </Col>

          <Col md={10} sm={10} xs={24}>
            <div style={styles.DestinatarioContainer}>
              <div style={{ display: 'flex' }}>
                <div style={styles.UserTitle}>
                  <Link
                    to={`/user/${swap.destinatario.username}`}
                    style={{ color: themeColors.secondary }}>
                    {swap.destinatario.username}
                  </Link>
                </div>
                <div style={styles.userLabel}>Destinatario</div>
              </div>
              <div style={{ display: 'flex' }}>
                <div>
                  <p style={styles.place}>
                    <FontIcon className="material-icons" style={iconStyle}>
                      place
                    </FontIcon>
                    <span style={{ position: 'relative', top: -7 }}>
                      {swap.destinatario.district}
                    </span>
                  </p>
                  <div style={{ height: 29 }}>
                    {destinatarioEsito &&
                      +destinatarioEsito.feedback > 0 && (
                        <div style={{ display: 'inline-flex' }}>
                          <p style={styles.feedback}>Feedback</p>
                          <Rating
                            value={destinatarioEsito.feedback}
                            readOnly={true}
                            itemStyle={styles.feedbackStars}
                            itemIconStyle={{ width: 17, height: 17 }}
                          />
                        </div>
                      )}
                  </div>
                </div>
                <div style={{ marginLeft: 'auto' }}>
                  {destinatarioItems.length === 0 ? (
                    <FlatButton
                      style={expandBtnStyle}
                      label={`${destinatarioCash} €`}
                      primary={true}
                    />
                  ) : (
                    <FlatButton
                      style={expandBtnStyle}
                      label={`${destinatarioItems.length} oggett${
                        destinatarioItems.length > 1 ? 'i' : 'o'
                      }${destinatarioCash ? ` + ${destinatarioCash} €` : ''}`}
                      labelPosition="before"
                      onClick={this.toggleExpandDestinatario}
                      secondary={true}
                      icon={
                        destinatarioItems.length > 1 && (
                          <FontIcon className="material-icons">
                            {this.state.expandedDestinatario
                              ? 'keyboard_arrow_up'
                              : 'keyboard_arrow_down'}
                          </FontIcon>
                        )
                      }
                    />
                  )}
                </div>
              </div>
            </div>
            {!!destinatarioItems.length && (
              <div
                style={
                  this.state.expandedDestinatario
                    ? {}
                    : {
                        position: 'relative',
                        height: destinatarioCollapsedHeight,
                      }
                }>
                {destinatarioItems.map((item, i) => (
                  <Card
                    key={item.oggetto.id}
                    containerStyle={objectCardStyle.containerStyle}
                    style={
                      this.state.expandedDestinatario
                        ? objectCardStyle.cardStyle
                        : {
                            position: 'relative',
                            top: -VERTIAL_SHIFT * i,
                            margin: 10,
                          }
                    }>
                    <CardMedia>
                      <FixedImg src={item.oggetto.immagine} height={100} />
                    </CardMedia>
                    <div style={styles.itemTitle}>{item.oggetto.titolo}</div>
                  </Card>
                ))}
              </div>
            )}
          </Col>
        </Row>
      </Card>
    )
  }
}



// WEBPACK FOOTER //
// ./src/common/ExchangeCard.js